/* Reserva de cita Fixel — asistente de dos flujos. Sin dependencias.
 *
 * Flujo A (tienda): dispositivo → reparación → tienda → día y hora → datos.
 *   No se cobra nada. La cita queda PENDIENTE DE CONFIRMACIÓN hasta que
 *   Atención al Cliente llama; eso se le dice al cliente con todas las letras
 *   para que no se presente pensando que está cerrada.
 *
 * Flujo B (domicilio): dispositivo → reparación → dirección y franja →
 *   código de desbloqueo y notas → fotos → datos → PAGO.
 *   El pago se hace en el checkout de Shopify. Aquí solo se registra la
 *   solicitud, se obtiene una referencia y se monta el carrito con esa
 *   referencia como atributo; el backend espera al webhook `orders/paid`.
 *
 * De dónde salen los datos:
 *   - El catálogo, de la propia tienda (`/search/suggest.json` y
 *     `/products/<handle>.js`). La página vive en fixelmovil.com, así que son
 *     llamadas del mismo origen: ni CORS ni claves ni catálogo duplicado.
 *   - Los huecos de agenda y el alta, del panel (`data-api`).
 *
 * Dos modos, el mismo código (`data-fxr-modo`):
 *   - `pagina`  (por defecto) — la página /pages/reservar-cita de siempre.
 *   - `popup`   — dentro de la ficha de producto. El modelo y la reparación
 *     llegan ya elegidos desde la ficha, así que esos dos pasos desaparecen y
 *     el asistente arranca en "elige tienda" o en "dónde lo recogemos". No se
 *     pide nada al panel hasta que el cliente abre el popup.
 */
(function () {
  'use strict';

  var NO_DISPONIBLE =
    'Las reservas online no están disponibles en este momento. ' +
    'Escríbenos por WhatsApp al 636 981 787 o llámanos y te damos cita al momento.';

  function init(root) {
    if (root.dataset.fxrReady) return;
    root.dataset.fxrReady = '1';

    var api = (root.dataset.api || '').replace(/\/+$/, '');
    var servicioId = (root.dataset.servicioVariante || '').trim();
    var servicioPrecio = parseFloat(root.dataset.servicioPrecio || '0') || 0;
    var monedaSufijo = ' €';
    var esPopup = (root.dataset.fxrModo || 'pagina') === 'popup';

    var pane = root.querySelector('[data-fxr-pane]');
    var bar = root.querySelector('[data-fxr-bar]');
    var etiqueta = root.querySelector('[data-fxr-label]');

    var estado = {
      flujo: null,
      prefijado: false,   // el modelo y la reparación vienen de la ficha
      producto: null,     // {title, handle, variants[]}
      variante: null,     // {id, title, price} — la primera de `seleccion`
      // La ficha de la tienda nueva permite elegir varias reparaciones con
      // cantidad. `seleccion` es siempre la lista completa (una entrada cuando
      // se elige en el propio asistente) y `variante` la primera, que es lo que
      // esperan las partes del código escritas cuando solo había una.
      seleccion: [],      // [{id, title, price, qty}]
      // Descuento que ya venía aplicado en la ficha (la promo de batería y las
      // que añadan). No se calcula aquí: se deduce de su total, ver `abrir`.
      descuento: 0,
      tienda: null,
      dias: [],
      dia: null,
      hueco: null,
      datos: {},
      fotos: { frontal: null, trasera: null },
      config: null,
      // Una reserva ya enviada: la ventana no debe retomarla al reabrirse.
      enviada: false,
      inicio: Date.now(),
      enviando: false
    };

    // ------------------------------------------------------------- utilidades

    function h(tag, attrs, hijos) {
      var nodo = document.createElement(tag);
      Object.keys(attrs || {}).forEach(function (k) {
        if (k === 'text') nodo.textContent = attrs[k];
        else if (k === 'html') nodo.innerHTML = attrs[k];
        else if (k.slice(0, 2) === 'on') nodo.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] !== null && attrs[k] !== undefined) nodo.setAttribute(k, attrs[k]);
      });
      (hijos || []).forEach(function (c) { if (c) nodo.appendChild(c); });
      return nodo;
    }

    function euros(n) {
      return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + monedaSufijo;
    }

    function icono(cuerpo) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
             'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + cuerpo + '</svg>';
    }

    var ICO = {
      tienda: '<path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v11h16V9"/><path d="M9 20v-6h6v6"/>',
      furgoneta: '<path d="M3 16V6h11v10"/><path d="M14 9h4l3 3v4h-7"/>' +
                 '<circle cx="7.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>',
      check: '<path d="M20 6L9 17l-5-5"/>',
      escudo: '<path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z"/><path d="M9 12l2 2 4-4"/>'
    };

    // Cualquier respuesta que no sea JSON (502 de nginx, panel en mantenimiento,
    // 404 porque aún no está desplegado) significa lo mismo para el cliente.
    function leer(r) {
      var tipo = r.headers.get('Content-Type') || '';
      if (tipo.indexOf('json') === -1) return { ok: false, error: NO_DISPONIBLE };
      return r.json().catch(function () { return { ok: false, error: NO_DISPONIBLE }; });
    }

    function get(url) {
      return fetch(url, { headers: { Accept: 'application/json' } }).then(leer)
        .catch(function () { return { ok: false, error: NO_DISPONIBLE }; });
    }

    // Los endpoints .js de Shopify (`/products/<handle>.js`) devuelven JSON
    // pero con Content-Type `text/javascript`, así que la comprobación de
    // arriba los tiraría. Aquí se parsea el cuerpo sin mirar la cabecera.
    function getJs(url) {
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    // ------------------------------------------------------------ estructura

    // Los pasos dependen del flujo elegido. El índice sirve para la barra de
    // progreso y para el botón "atrás".
    //
    // Cuando el modelo y la reparación llegan ya elegidos desde la ficha de
    // producto, esos dos pasos salen de la lista. Todo se navega en relativo
    // (`avanza`/`repinta`), así que la barra de progreso, el "Atrás" y los
    // saltos se ajustan solos: no hay ningún índice escrito a mano que se
    // descoloque al quitar pasos.
    function pasos() {
      var previos = estado.prefijado ? [] : [pasoDispositivo, pasoReparacion];
      if (estado.flujo === 'tienda') {
        return previos.concat([pasoTienda, pasoDiaHora, pasoDatosTienda]);
      }
      if (estado.flujo === 'domicilio') {
        return previos.concat([pasoDireccion, pasoCodigo, pasoFotos, pasoDatosDomicilio]);
      }
      return [];
    }

    var indice = -1;  // -1 = elección de flujo

    function ir(nuevo) {
      indice = nuevo;
      var lista = pasos();
      if (indice < 0) { pintarVias(); return; }
      lista[Math.min(indice, lista.length - 1)]();
    }

    function avanza() { ir(indice + 1); }
    function repinta() { ir(indice); }

    function progreso() {
      var lista = pasos();
      var total = lista.length + 1;
      var hecho = indice + 1;
      bar.style.width = (total ? (hecho / total) * 100 : 0) + '%';
      etiqueta.textContent = indice < 0 ? '¿Cómo lo prefieres?' : 'Paso ' + hecho + ' de ' + total;
    }

    function nombreDispositivo() {
      return ((estado.producto || {}).title || '').replace(/^Reparar\s+/i, '');
    }

    // Un único sitio donde se fija qué reparaciones lleva la reserva, para que
    // `variante` y `seleccion` no puedan quedar descuadradas.
    function fijaSeleccion(lista) {
      estado.seleccion = (lista || []).map(function (x) {
        return { id: x.id, title: x.title, price: x.price, qty: Math.max(1, parseInt(x.qty || 1, 10)) };
      });
      estado.variante = estado.seleccion.length ? estado.seleccion[0] : null;
    }

    // Suma sin descuentos.
    function sumaReparaciones() {
      return estado.seleccion.reduce(function (suma, x) { return suma + x.price * x.qty; }, 0);
    }

    // Lo que se le va a pedir al cliente: la suma menos lo que la ficha ya le
    // había descontado.
    function totalReparaciones() {
      return Math.max(0, redondea(sumaReparaciones() - (estado.descuento || 0)));
    }

    function redondea(n) {
      return Math.round(n * 100) / 100;
    }

    // Texto corto para el campo `reparacion` del panel, que admite 200
    // caracteres. Con varias reparaciones se unen; el detalle completo va en los
    // comentarios, donde no hay límite que lo corte por la mitad.
    function textoReparaciones() {
      var partes = estado.seleccion.map(function (x) {
        return (x.qty > 1 ? x.qty + '× ' : '') + x.title;
      });
      var t = partes.join(' + ');
      return t.length > 200 ? t.slice(0, 197) + '…' : t;
    }

    // Red de seguridad: si el panel todavía no guarda la lista de reparaciones,
    // el desglose se cuela en los comentarios para que el equipo no se quede sin
    // saber qué ha pedido el cliente. Con un panel al día no se duplica.
    function detalleReparaciones() {
      if (estado.seleccion.length < 2) return '';
      if ((estado.config || {}).reparaciones_multiples === true) return '';
      var lineas = estado.seleccion.map(function (x) {
        return '. ' + (x.qty > 1 ? x.qty + 'x ' : '') + x.title + ': ' + euros(x.price * x.qty);
      });
      if (estado.descuento > 0) lineas.push('. Descuento aplicado: -' + euros(estado.descuento));
      return 'Reparaciones seleccionadas (' + estado.seleccion.length + '):\n' +
             lineas.join('\n') + '\nTotal reparaciones: ' + euros(totalReparaciones());
    }

    // Si el modelo y la reparación vienen de la ficha, el cliente tiene que ver
    // qué se ha traído el popup y poder cambiarlo sin cerrarlo: si no, un clic
    // en la reparación equivocada obliga a salir y volver a empezar.
    function cabeceraPrefijada() {
      if (!esPopup || !estado.prefijado || indice < 0) return null;
      if (!estado.producto || !estado.seleccion.length) return null;

      var lista = h('span', { class: 'fxr-elegido-lista' });
      estado.seleccion.forEach(function (x) {
        lista.appendChild(h('span', { class: 'fxr-elegido-linea' }, [
          h('span', { text: (x.qty > 1 ? x.qty + '× ' : '') + x.title }),
          h('b', { text: euros(x.price * x.qty) })
        ]));
      });

      if (estado.descuento > 0) {
        lista.appendChild(h('span', { class: 'fxr-elegido-linea fxr-elegido-promo' }, [
          h('span', { text: 'Descuento aplicado' }),
          h('b', { text: '-' + euros(estado.descuento) })
        ]));
      }

      var pie = h('span', { class: 'fxr-elegido-pie' }, [
        h('button', {
          type: 'button', class: 'fxr-elegido-cambiar',
          text: estado.seleccion.length > 1 ? 'Cambiar las reparaciones' : 'Cambiar la reparación',
          // Volver a la ficha es mejor que repetir aquí el selector: allí están
          // las categorías, los tiempos, la promo y las descripciones.
          onclick: function () { volverAReparaciones(); }
        })
      ]);
      if (estado.seleccion.length > 1) {
        pie.appendChild(h('span', { class: 'fxr-elegido-total',
          text: 'Total reparaciones: ' + euros(totalReparaciones()) }));
      }

      return h('div', { class: 'fxr-elegido' }, [
        h('b', { class: 'fxr-elegido-modelo', text: nombreDispositivo() }),
        lista,
        pie
      ]);
    }

    // En el popup se avisa a la ficha para que cierre la ventana y lleve al
    // cliente al selector; en la página no hay ficha a la que volver, así que se
    // usa el paso de siempre.
    function volverAReparaciones() {
      if (esPopup) {
        root.dispatchEvent(new CustomEvent('fxr:volver-a-reparaciones', { bubbles: true }));
        return;
      }
      estado.prefijado = false;
      ir(1);
    }

    function pintar(nodos) {
      pane.innerHTML = '';
      var caja = h('div', { class: 'fxr-pane' });
      var cabecera = cabeceraPrefijada();
      if (cabecera) caja.appendChild(cabecera);
      nodos.forEach(function (n) { if (n) caja.appendChild(n); });
      pane.appendChild(caja);
      progreso();
      var foco = caja.querySelector('input:not([type=file]), select, textarea');
      if (foco && indice > 0) foco.focus({ preventScroll: true });
      // Dentro del popup no se toca el scroll de la página: se sube el propio
      // cuerpo del popup, que es lo que el cliente está mirando.
      if (esPopup) {
        var cuerpo = root.querySelector('[data-fxr-cuerpo]') || root;
        cuerpo.scrollTop = 0;
      // Al avanzar en móvil, el asistente se queda fuera de pantalla si no se
      // sube: el usuario ve el paso nuevo a medias y cree que no ha pasado nada.
      } else if (indice > 0) {
        // La cabecera del tema es pegajosa: sin dejarle sitio, el titular del
        // paso nuevo queda debajo de ella y parece que no ha pasado nada.
        var cabeceraTema = document.querySelector('.cc-header--sticky, .header--sticky, header[role="banner"]');
        var margen = (cabeceraTema ? cabeceraTema.offsetHeight : 0) + 20;
        var arriba = root.getBoundingClientRect().top + window.scrollY - margen;
        if (window.scrollY > arriba) window.scrollTo({ top: Math.max(0, arriba), behavior: 'smooth' });
      }
    }

    function titulo(texto, ayuda) {
      return [h('h2', { class: 'fxr-q', text: texto }),
              ayuda ? h('p', { class: 'fxr-help', text: ayuda }) : null];
    }

    function nav(opciones) {
      var hijos = [];
      if (opciones.atras !== false) {
        hijos.push(h('button', {
          type: 'button', class: 'fxr-btn fxr-btn-ghost', text: 'Atrás',
          onclick: function () { ir(indice - 1); }
        }));
      }
      hijos.push(h('span', { class: 'fxr-spacer' }));
      if (opciones.nota) hijos.push(h('span', { class: 'fxr-mini', text: opciones.nota }));
      if (opciones.siguiente) hijos.push(opciones.siguiente);
      return h('div', { class: 'fxr-nav' }, hijos);
    }

    function boton(texto, onclick, attrs) {
      return h('button', Object.assign({
        type: 'button', class: 'fxr-btn', text: texto, onclick: onclick
      }, attrs || {}));
    }

    function aviso(texto) {
      return h('p', { class: 'fxr-alert', text: texto });
    }

    // ------------------------------------------------------- paso 0: las vías

    function pintarVias() {
      var cfg = estado.config || {};
      var vias = [];

      vias.push(h('button', {
        type: 'button', class: 'fxr-opt fxr-via', onclick: function () { elegirFlujo('tienda'); }
      }, [h('span', {}, [
        h('span', { class: 'fxr-via-ico', html: icono(ICO.tienda) }),
        h('b', { text: 'Lo llevo a la tienda' }),
        h('span', { text: 'Eliges tienda, día y hora. No pagas nada ahora: se paga al recoger el dispositivo reparado.' }),
        h('span', { class: 'fxr-badge fxr-badge-ok', text: 'Sin pago por adelantado' })
      ])]));

      // El producto que cobra la recogida solo hace falta si hay que cobrarla.
      // Cuando el panel dice que se paga al reparar no hay nada que cobrar
      // online, así que exigirlo dejaría la vía escondida sin motivo.
      // Con cobro por adelantado y sin producto sí se esconde: mejor una vía
      // menos que una vía que acaba en un checkout imposible.
      if (cfg.domicilio && (servicioId || cobraAlReparar())) {
        vias.push(h('button', {
          type: 'button', class: 'fxr-opt fxr-via', onclick: function () { elegirFlujo('domicilio'); }
        }, [h('span', {}, [
          h('span', { class: 'fxr-via-ico', html: icono(ICO.furgoneta) }),
          h('b', { text: 'Que lo recojan en mi casa' }),
          // El texto tiene que decir lo que de verdad va a pasar en el paso del
          // pago, y eso depende del modo que diga el panel.
          h('span', {
            text: cobraAlReparar()
              ? 'Un mensajero lo recoge, lo reparamos y te lo devolvemos. No pagas nada al ' +
                'reservar: se paga cuando te lo devolvemos reparado.'
              : 'Un mensajero lo recoge, lo reparamos y te lo devolvemos. ' +
                'Se paga online al reservar (reparación + recogida + entrega).'
          }),
          h('span', {
            class: cobraAlReparar() ? 'fxr-badge fxr-badge-ok' : 'fxr-badge',
            text: cobraAlReparar()
              ? 'Recogida y entrega gratis dentro de la M-30'
              : (servicioPrecio ? 'Recogida y entrega: ' + euros(servicioPrecio) : 'Pago online')
          })
        ])]));
      }

      pintar([].concat(
        titulo('¿Cómo prefieres que lo hagamos?',
               'Las dos opciones incluyen diagnóstico y garantía. Elige la que te venga mejor.'),
        [h('div', { class: 'fxr-vias' }, vias)],
        [h('p', { class: 'fxr-mini', text: 'Reparamos en Madrid. Tardas menos de dos minutos en reservar.' })]
      ));
    }

    function elegirFlujo(flujo) {
      estado.flujo = flujo;
      ir(0);
    }

    // ------------------------------------------ paso 1: modelo del dispositivo

    var temporizador = null;

    function pasoDispositivo() {
      // OJO: `type="search"` no. El buscador predictivo del tema se engancha a
      // cualquier input de ese tipo que haya en la pagina, carga sus propios
      // assets y deja este campo inservible. Con `type="text"` +
      // `inputmode="search"` se comporta igual para el usuario y nadie lo toca.
      var campo = h('input', {
        class: 'fxr-input', type: 'text', inputmode: 'search', enterkeyhint: 'search',
        autocomplete: 'off', spellcheck: 'false',
        placeholder: 'Escribe tu modelo. Por ejemplo: iPhone 13',
        'aria-label': 'Buscar el modelo de tu dispositivo',
        value: estado.producto ? estado.producto.title.replace(/^Reparar\s+/i, '') : ''
      });
      var resultados = h('div', { class: 'fxr-results' });

      function buscar() {
        var q = campo.value.trim();
        if (q.length < 2) { resultados.innerHTML = ''; return; }
        resultados.innerHTML = '';
        resultados.appendChild(h('div', { class: 'fxr-skeleton' }));
        // El catálogo de reparaciones son productos "Reparar <modelo>", así que
        // se busca con ese prefijo para no mezclar con los reacondicionados.
        var url = '/search/suggest.json?q=' + encodeURIComponent('Reparar ' + q) +
                  '&resources[type]=product&resources[limit]=10';
        get(url).then(function (data) {
          var lista = ((((data || {}).resources || {}).results || {}).products) || [];
          lista = lista.filter(function (p) { return /^reparar/i.test(p.title || ''); });
          resultados.innerHTML = '';
          if (!lista.length) {
            resultados.appendChild(h('p', { class: 'fxr-mini',
              text: 'No encontramos ese modelo. Prueba a escribirlo de otra forma, ' +
                    'o sigue y cuéntanoslo en el paso de comentarios.' }));
            return;
          }
          lista.slice(0, 8).forEach(function (p) {
            resultados.appendChild(h('button', {
              type: 'button', class: 'fxr-result',
              onclick: function () { elegirProducto(p.handle); }
            }, [
              h('strong', { text: (p.title || '').replace(/^Reparar\s+/i, '') }),
              h('span', { text: 'Ver reparaciones' })
            ]));
          });
        });
      }

      campo.addEventListener('input', function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(buscar, 230);
      });

      pintar([].concat(
        titulo('¿Qué dispositivo hay que reparar?',
               'Busca tu modelo para ver las reparaciones y sus precios reales.'),
        [h('div', { class: 'fxr-search' }, [campo]), resultados],
        [nav({ atras: true })]
      ));
      if (campo.value) buscar();
    }

    // El tiempo de reparación y la garantía viven en metafields de la variante,
    // y `/products/<handle>.js` no los trae. Se piden aparte a la plantilla
    // `?view=reserva-datos` y se cruzan por id de variante. Si esa llamada falla
    // —tema antiguo, vista sin publicar— el asistente sigue funcionando igual
    // que antes: simplemente no enseña esos dos datos.
    function conMetadatos(p, handle) {
      return getJs('/products/' + handle + '?view=reserva-datos').then(function (extra) {
        if (!extra || !extra.variants) return p;
        var porId = {};
        extra.variants.forEach(function (v) { porId[v.id] = v; });
        p.variants.forEach(function (v) {
          var e = porId[v.id];
          if (!e) return;
          v.tiempo = e.tiempo || null;
          v.garantia = e.garantia || null;
          v.resumen = e.resumen || null;
        });
        p.aviso_tiempo = extra.aviso_tiempo || null;
        return p;
      }).catch(function () { return p; });
    }

    function elegirProducto(handle) {
      getJs('/products/' + handle + '.js').then(function (p) {
        if (!p || !p.variants) {
          var previo = pane.querySelector('.fxr-alert');
          if (previo) previo.remove();
          pane.appendChild(aviso('No hemos podido cargar ese modelo. Prueba con otro.'));
          return;
        }
        return conMetadatos(p, handle).then(function (completo) {
          estado.producto = completo;
          fijaSeleccion([]);
          avanza();
        });
      });
    }

    // ------------------------------------------------- paso 2: la reparación

    // Los tiempos están escritos a mano en el catálogo y no siguen un formato
    // único: conviven "60 minutos", "60 min", "1 hora 30 minutos", "24-72 horas"
    // y "24–72 h" con guión largo. Se unifican solo para pintarlos; en Shopify
    // se queda lo que haya escrito cada uno.
    function tiempoBonito(txt) {
      return String(txt)
        .replace(/–|—/g, '-')
        .replace(/\bminutos?\b/gi, 'min')
        .replace(/\bhoras?\b/gi, 'h')
        .replace(/\s*-\s*/g, '-')
        .replace(/\s+/g, ' ')
        .trim();
    }

    // "No aplica" es una respuesta legítima del catálogo (un diagnóstico o un
    // cristal de cámara no llevan garantía). No se pinta: mejor no decir nada
    // que escribir "Garantía No aplica".
    function garantiaBonita(txt) {
      var t = String(txt || '').trim();
      if (!t || /^(no\s*aplica|no|n\/a|-)$/i.test(t)) return null;
      return /garant/i.test(t) ? t : 'Garantía ' + t;
    }

    function pasoReparacion() {
      if (!estado.producto) { ir(0); return; }
      var opciones = h('div', { class: 'fxr-options' });
      var algunTiempo = false;

      estado.producto.variants.forEach(function (v) {
        if (v.available === false) return;
        var precio = v.price / 100;

        // Solo se enseña lo que el catálogo diga de verdad. Donde todavía no
        // hay datos se deja el texto genérico de siempre, sin inventar plazos
        // ni meses de garantía.
        var detalles = [];
        if (v.tiempo) { detalles.push('⏱ ' + tiempoBonito(v.tiempo)); algunTiempo = true; }
        var gar = garantiaBonita(v.garantia);
        if (gar) detalles.push(gar);
        var pista = detalles.length ? detalles.join(' · ') : 'Con garantía Fixel';

        opciones.appendChild(h('button', {
          type: 'button', class: 'fxr-opt',
          'aria-pressed': estado.variante && estado.variante.id === v.id ? 'true' : 'false',
          onclick: function () { fijaSeleccion([{ id: v.id, title: v.title, price: precio, qty: 1 }]); avanza(); }
        }, [
          h('span', { class: 'fxr-opt-body' }, [
            h('span', { class: 'fxr-opt-label', text: v.title }),
            h('span', { class: 'fxr-opt-hint', text: pista })
          ]),
          h('span', { class: 'fxr-opt-price', text: euros(precio) })
        ]));
      });

      // El aviso de que los tiempos son orientativos solo tiene sentido si se
      // ha llegado a enseñar algún tiempo.
      var pie = [];
      if (algunTiempo) {
        pie.push(h('p', { class: 'fxr-mini fxr-nota-tiempo',
          text: estado.producto.aviso_tiempo
            || 'Los tiempos son orientativos: pueden variar según la carga de trabajo y la disponibilidad de la pieza.' }));
      }

      pintar([].concat(
        titulo('¿Qué le pasa a tu ' + estado.producto.title.replace(/^Reparar\s+/i, '') + '?',
               'Si no lo tienes claro, elige el diagnóstico: lo revisamos y te llamamos antes de tocar nada.'),
        [opciones],
        pie,
        [nav({ atras: true })]
      ));
    }

    // --------------------------------------------- paso 3A: elegir la tienda

    function pasoTienda() {
      var cfg = estado.config || { tiendas: [] };
      var opciones = h('div', { class: 'fxr-options' });

      (cfg.tiendas || []).forEach(function (t) {
        opciones.appendChild(h('button', {
          type: 'button', class: 'fxr-opt',
          'aria-pressed': estado.tienda === t.id ? 'true' : 'false',
          onclick: function () {
            if (estado.tienda !== t.id) { estado.dia = null; estado.hueco = null; }
            estado.tienda = t.id;
            avanza();
          }
        }, [
          h('span', { class: 'fxr-opt-body' }, [
            h('span', { class: 'fxr-opt-label', text: t.nombre }),
            h('span', { class: 'fxr-opt-hint', text: t.direccion + ' · Metro ' + t.metro })
          ])
        ]));
      });

      pintar([].concat(
        titulo('¿A qué tienda te viene mejor?', 'Las dos están en el centro de Madrid.'),
        [opciones],
        [nav({ atras: true })]
      ));
    }

    // ---------------------------------------------- paso 4A: el día y la hora

    function pasoDiaHora() {
      var contenedor = h('div', {}, [h('div', { class: 'fxr-skeleton' })]);
      pintar([].concat(
        titulo('Elige día y hora', 'Te reservamos ese hueco mientras confirmamos la cita contigo.'),
        [contenedor],
        [nav({ atras: true })]
      ));

      get(api + '/api/reserva/huecos?store_id=' + encodeURIComponent(estado.tienda)).then(function (data) {
        if (!data.ok || !(data.dias || []).length) {
          contenedor.innerHTML = '';
          contenedor.appendChild(notaConContacto(
            'Ahora mismo no podemos mostrarte los huecos',
            'Contáctanos y buscaremos contigo una hora disponible.'
          ));
          return;
        }
        estado.dias = data.dias;
        pintarDias(contenedor);
      });
    }

    function pintarDias(contenedor) {
      contenedor.innerHTML = '';
      var tiraDias = h('div', { class: 'fxr-dias' });
      var zonaHuecos = h('div', {});

      estado.dias.forEach(function (d, i) {
        // El backend manda "lunes 18 agosto". En la pastilla caben el número y
        // el día de la semana abreviado; el mes iría repetido en todas y solo
        // añade ruido, así que se queda en el aria-label.
        var partes = (d.label || '').split(' ');
        var boton = h('button', {
          type: 'button', class: 'fxr-dia', 'aria-label': d.label,
          'aria-pressed': (estado.dia || (i === 0 ? d.date : null)) === d.date ? 'true' : 'false',
          onclick: function () {
            estado.dia = d.date;
            estado.hueco = null;
            pintarDias(contenedor);
          }
        }, [
          h('b', { text: partes[1] || d.date.slice(-2) }),
          h('span', { text: (partes[0] || '').slice(0, 3) })
        ]);
        tiraDias.appendChild(boton);
      });

      if (!estado.dia && estado.dias.length) estado.dia = estado.dias[0].date;
      contenedor.appendChild(tiraDias);
      contenedor.appendChild(zonaHuecos);

      zonaHuecos.appendChild(h('div', { class: 'fxr-skeleton' }));
      get(api + '/api/reserva/huecos?store_id=' + encodeURIComponent(estado.tienda) +
          '&dia=' + encodeURIComponent(estado.dia)).then(function (data) {
        zonaHuecos.innerHTML = '';
        var huecos = (data && data.huecos) || [];
        if (!huecos.length) {
          zonaHuecos.appendChild(h('p', { class: 'fxr-mini', text: 'Ese día ya no quedan huecos. Prueba con otro.' }));
          return;
        }
        var rejilla = h('div', { class: 'fxr-huecos' });
        huecos.forEach(function (s) {
          rejilla.appendChild(h('button', {
            type: 'button', class: 'fxr-hueco', text: s.time,
            'aria-pressed': estado.hueco === s.starts_at ? 'true' : 'false',
            onclick: function () {
              estado.hueco = s.starts_at;
              rejilla.querySelectorAll('.fxr-hueco').forEach(function (b) {
                b.setAttribute('aria-pressed', 'false');
              });
              this.setAttribute('aria-pressed', 'true');
              siguiente.disabled = false;
            }
          }));
        });
        zonaHuecos.appendChild(rejilla);
      });

      var siguiente = boton('Continuar', avanza, { disabled: estado.hueco ? null : 'disabled' });
      contenedor.parentNode.replaceChild(
        nav({ atras: true, siguiente: siguiente }),
        contenedor.parentNode.querySelector('.fxr-nav')
      );
    }

    // ----------------------------------------- paso 3B: dirección de recogida

    function campo(clave, etiquetaTexto, opciones) {
      opciones = opciones || {};
      var control;
      if (opciones.tipo === 'textarea') {
        control = h('textarea', {
          id: 'fxr-' + clave, name: clave, rows: opciones.filas || 3,
          placeholder: opciones.placeholder || '', text: estado.datos[clave] || ''
        });
      } else if (opciones.tipo === 'select') {
        control = h('select', { id: 'fxr-' + clave, name: clave });
        if (opciones.placeholder) {
          var vacia = document.createElement('option');
          vacia.value = '';
          vacia.textContent = opciones.placeholder;
          vacia.disabled = true;
          if (!estado.datos[clave]) vacia.selected = true;
          control.appendChild(vacia);
        }
        (opciones.opciones || []).forEach(function (o) {
          var op = h('option', { value: o.id, text: o.label });
          if (estado.datos[clave] === o.id) op.setAttribute('selected', 'selected');
          control.appendChild(op);
        });
      } else {
        control = h('input', {
          id: 'fxr-' + clave, name: clave, type: opciones.tipo || 'text',
          autocomplete: opciones.autocomplete || 'on',
          inputmode: opciones.inputmode || null,
          placeholder: opciones.placeholder || '',
          value: estado.datos[clave] || ''
        });
      }
      control.addEventListener('input', function () {
        estado.datos[clave] = control.value;
        control.parentNode.classList.remove('fxr-error');
      });
      control.addEventListener('change', function () { estado.datos[clave] = control.value; });

      return h('div', { class: 'fxr-field' + (opciones.ancho ? ' fxr-wide' : ''), 'data-campo': clave }, [
        h('label', { for: 'fxr-' + clave, text: etiquetaTexto }),
        control,
        opciones.ayuda ? h('small', { text: opciones.ayuda }) : null
      ]);
    }

    function marcaError(clave, mensaje) {
      var caja = pane.querySelector('[data-campo="' + clave + '"]');
      if (caja) {
        caja.classList.add('fxr-error');
        var previo = caja.querySelector('.fxr-field-error');
        if (previo) previo.remove();
        caja.appendChild(h('p', { class: 'fxr-field-error', text: mensaje }));
        caja.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var control = caja.querySelector('input, select, textarea');
        if (control) control.focus({ preventScroll: true });
      }
    }

    function pasoDireccion() {
      var cfg = estado.config || {};
      var campos = h('div', { class: 'fxr-fields' }, [
        campo('direccion', 'Dirección completa de recogida', {
          ancho: true, autocomplete: 'street-address',
          placeholder: 'Calle, número, piso y puerta',
          ayuda: 'Necesitamos el piso y la puerta: el mensajero no puede llamar a todos los timbres.'
        }),
        campo('cp', 'Código postal', { inputmode: 'numeric', autocomplete: 'postal-code', placeholder: '28015' }),
        campo('ciudad', 'Localidad', { autocomplete: 'address-level2', placeholder: 'Madrid' }),
        campo('franja', 'Franja horaria preferida para la recogida', {
          ancho: true, tipo: 'select', opciones: cfg.franjas || [], placeholder: 'Elige una franja',
          ayuda: 'Es una preferencia: te llamamos antes para confirmar el día concreto.'
        })
      ]);

      pintar([].concat(
        titulo('¿Dónde lo recogemos?', 'Recogemos y entregamos en Madrid capital.'),
        [campos],
        [nav({
          atras: true,
          siguiente: boton('Continuar', function () {
            if (!(estado.datos.direccion || '').trim()) return marcaError('direccion', 'Necesitamos la dirección.');
            if (!/^\d{5}$/.test((estado.datos.cp || '').trim())) return marcaError('cp', 'El código postal son 5 cifras.');
            if (!(estado.datos.ciudad || '').trim()) return marcaError('ciudad', 'Falta la localidad.');
            if (!estado.datos.franja) return marcaError('franja', 'Elige una franja horaria para la recogida.');
            avanza();
          })
        })]
      ));
    }

    function consentimiento(clave, texto, siguiente, puedeContinuar, nota) {
      var id = 'fxr-consent-' + clave;
      var control = h('input', { type: 'checkbox', id: id });
      control.checked = !!estado.datos[clave];
      var caja = h('div', { class: 'fxr-consent', 'data-campo': clave }, [
        h('label', { for: id }, [control, h('span', { text: texto })])
      ]);

      function actualiza() {
        var fotosListas = !puedeContinuar || puedeContinuar();
        siguiente.disabled = !(control.checked && fotosListas);
        if (nota) {
          nota.textContent = !fotosListas
            ? 'Faltan las dos fotos del dispositivo.'
            : (control.checked ? '' : 'Marca la casilla para continuar.');
        }
        caja.classList.remove('fxr-error');
        var error = caja.querySelector('.fxr-field-error');
        if (error) error.remove();
      }

      control.addEventListener('change', function () {
        estado.datos[clave] = control.checked;
        actualiza();
      });
      actualiza();
      return caja;
    }

    // --------------------------------- paso 4B: código de desbloqueo y notas

    function pasoCodigo() {
      var seguir = boton('Continuar', function () {
        if (!estado.datos.consentimiento_codigo) {
          return marcaError('consentimiento_codigo', 'Es necesario aceptar el uso temporal del código.');
        }
        if (!(estado.datos.codigo_desbloqueo || '').trim()) {
          return marcaError('codigo_desbloqueo', 'Sin el código no podemos probar la reparación.');
        }
        if (!(estado.datos.comentarios || '').trim()) {
          return marcaError('comentarios', 'Cuéntanos brevemente qué le pasa.');
        }
        avanza();
      });
      var aceptaCodigo = consentimiento(
        'consentimiento_codigo',
        'Autorizo a Fixel a utilizar temporalmente el código de desbloqueo de mi dispositivo únicamente para realizar las pruebas necesarias de diagnóstico y reparación.',
        seguir
      );
      var campos = h('div', { class: 'fxr-fields' }, [
          campo('codigo_desbloqueo', 'Código de desbloqueo del dispositivo', {
            ancho: true, tipo: 'password', autocomplete: 'off',
            placeholder: 'Introduce el código o describe el patrón'
        }),
        h('div', { class: 'fxr-wide' }, [aceptaCodigo]),
        campo('comentarios', 'Comentarios sobre la reparación', {
          ancho: true, tipo: 'textarea', filas: 4,
          placeholder: 'Cuéntanos qué le pasa, desde cuándo, si se ha mojado o si ya lo ha visto otro técnico.'
        })
      ]);

      pintar([].concat(
        titulo('Un par de cosas para poder repararlo bien'),
        [h('div', { class: 'fxr-note' }, [
          h('b', { text: 'Uso del código de desbloqueo' }),
          h('span', {
            text: 'El código se guarda cifrado y solo se utiliza temporalmente para las pruebas ' +
                  'de diagnóstico y reparación. No lo incluimos en los correos ni en los avisos.'
          })
        ])],
        [campos],
        [nav({ atras: true, siguiente: seguir })]
      ));
    }

    // ------------------------------------------------- paso 5B: las dos fotos

    function cajaFoto(clave, titulo0, ayuda) {
      var caja = h('label', { class: 'fxr-foto' + (estado.fotos[clave] ? ' fxr-lista' : '') });
      var entrada = h('input', { type: 'file', accept: 'image/*', name: 'foto_' + clave });

      entrada.addEventListener('change', function () {
        var fichero = entrada.files && entrada.files[0];
        if (!fichero) return;
        if (fichero.size > 8 * 1024 * 1024) {
          alert('Esa foto pesa más de 8 MB. Hazla con menos calidad o recórtala.');
          entrada.value = '';
          return;
        }
        estado.fotos[clave] = fichero;
        repinta();  // el paso se vuelve a pintar con la vista previa
      });

      if (estado.fotos[clave]) {
        var img = h('img', { alt: titulo0 });
        img.src = URL.createObjectURL(estado.fotos[clave]);
        img.addEventListener('load', function () { URL.revokeObjectURL(img.src); });
        caja.appendChild(img);
        caja.appendChild(h('div', { class: 'fxr-foto-pie' }, [
          h('b', { text: titulo0 }),
          h('span', { class: 'fxr-foto-cambiar', text: 'Cambiar' })
        ]));
      } else {
        caja.appendChild(h('b', { text: titulo0 }));
        caja.appendChild(h('span', { text: ayuda }));
      }
      caja.appendChild(entrada);
      return caja;
    }

    function pasoFotos() {
      var listas = estado.fotos.frontal && estado.fotos.trasera;
      var notaConsentimiento = h('span', { class: 'fxr-mini' });
      var seguir = boton('Continuar', avanza, {
        disabled: listas && estado.datos.consentimiento_fotos ? null : 'disabled'
      });
      var aceptaFotos = consentimiento(
        'consentimiento_fotos',
        'Confirmo que las fotografías adjuntas corresponden al dispositivo que voy a enviar a Fixel para su reparación.',
        seguir,
        function () { return !!listas; },
        notaConsentimiento
      );
      pintar([].concat(
        titulo('Dos fotos del dispositivo'),
        [h('div', { class: 'fxr-note fxr-note-red' }, [
          h('b', { text: 'Fotografías del dispositivo' }),
          h('span', {
            text: 'Es obligatorio adjuntar una fotografía de la parte delantera y otra de la ' +
                  'parte trasera del dispositivo. Estas imágenes nos permiten verificar el ' +
                  'estado estético antes del transporte y sirven como prueba en caso de ' +
                  'incidencias con la empresa de mensajería, facilitando cualquier ' +
                  'reclamación que pudiera ser necesaria.'
          })
        ])],
        [h('div', { class: 'fxr-fotos' }, [
          cajaFoto('frontal', 'Parte delantera', 'Toca para hacer o elegir la foto'),
          cajaFoto('trasera', 'Parte trasera', 'Toca para hacer o elegir la foto')
        ])],
        [aceptaFotos],
        [nav({ atras: true, nota: notaConsentimiento, siguiente: seguir })]
      ));
    }

    // ------------------------------------------------- paso final: tus datos

    function camposPersonales(conCanal) {
      var cfg = estado.config || {};
      var hijos = [
        campo('nombre', 'Nombre y apellidos', { ancho: true, autocomplete: 'name' }),
        campo('telefono', 'Teléfono móvil', { tipo: 'tel', inputmode: 'tel', autocomplete: 'tel' }),
        campo('email', 'Correo electrónico', { tipo: 'email', inputmode: 'email', autocomplete: 'email' })
      ];
      if (conCanal) {
        hijos.push(campo('canal', '¿Cómo nos conociste?', {
          ancho: true, tipo: 'select',
          opciones: [{ id: '', label: 'Elige una opción' }].concat(cfg.canales || [])
        }));
      }
      return h('div', { class: 'fxr-fields' }, hijos);
    }

    function validaPersonales(conCanal) {
      var d = estado.datos;
      if ((d.nombre || '').trim().split(/\s+/).length < 2) {
        marcaError('nombre', 'Escribe nombre y apellidos.'); return false;
      }
      if (!/^[+0-9\s().-]{9,20}$/.test((d.telefono || '').trim())) {
        marcaError('telefono', 'Ese teléfono no parece válido.'); return false;
      }
      if (!/^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/.test((d.email || '').trim())) {
        marcaError('email', 'Ese correo no parece válido.'); return false;
      }
      if (conCanal && !d.canal) {
        marcaError('canal', 'Cuéntanos cómo nos conociste.'); return false;
      }
      return true;
    }

    // Lo decide el panel (`cobro_domicilio`), no el tema: si lo mandara el
    // navegador, cualquiera podría saltarse el pago.
    function cobraAlReparar() {
      return (estado.config || {}).cobro_domicilio === 'al_reparar';
    }

    function resumen(conServicio) {
      var precio = totalReparaciones();
      var filas = estado.seleccion.map(function (x) {
        return h('div', { class: 'fxr-resumen-fila' }, [
          h('span', {
            text: nombreDispositivo() + ' · ' + (x.qty > 1 ? x.qty + '× ' : '') + x.title
          }),
          h('b', { text: euros(x.price * x.qty) })
        ]);
      });
      if (!filas.length) {
        filas = [h('div', { class: 'fxr-resumen-fila' }, [
          h('span', { text: nombreDispositivo() || 'Reparación' }),
          h('b', { text: euros(0) })
        ])];
      }
      if (estado.descuento > 0) {
        filas.push(h('div', { class: 'fxr-resumen-fila fxr-resumen-promo' }, [
          h('span', { text: 'Descuento aplicado' }),
          h('b', { text: '-' + euros(estado.descuento) })
        ]));
      }
      if (conServicio && cobraAlReparar()) {
        // No se cobra nada al reservar, así que tampoco se cobra la recogida:
        // el total es el presupuesto de la reparación y se paga al devolverla.
        filas.push(h('div', { class: 'fxr-resumen-fila' }, [
          h('span', { text: 'Recogida y entrega a domicilio' }),
          h('b', { class: 'fxr-opt-free', text: 'Gratis dentro de la M-30' })
        ]));
        filas.push(h('div', { class: 'fxr-resumen-fila fxr-resumen-total' }, [
          h('span', { text: 'Presupuesto, a pagar al devolverlo reparado' }),
          h('b', { text: euros(precio) })
        ]));
      } else if (conServicio) {
        filas.push(h('div', { class: 'fxr-resumen-fila' }, [
          h('span', { text: 'Recogida y entrega a domicilio' }),
          h('b', { text: euros(servicioPrecio) })
        ]));
        filas.push(h('div', { class: 'fxr-resumen-fila fxr-resumen-total' }, [
          h('span', { text: 'Total a pagar ahora' }),
          h('b', { text: euros(precio + servicioPrecio) })
        ]));
      } else {
        filas.push(h('div', { class: 'fxr-resumen-fila fxr-resumen-total' }, [
          h('span', { text: 'A pagar al recoger' }),
          h('b', { text: euros(precio) })
        ]));
      }
      return h('div', { class: 'fxr-resumen' }, filas);
    }

    function pasoDatosTienda() {
      var enviar = boton('Solicitar cita', function () {
        if (!validaPersonales(true)) return;
        enviaTienda(enviar);
      });

      pintar([].concat(
        titulo('¿Cómo te localizamos?',
               'Te llamamos para confirmar la cita y comprobar que tenemos la pieza.'),
        [camposPersonales(true)],
        [h('div', { style: 'height:18px' })],
        [resumen(false)],
        [h('div', { class: 'fxr-note' }, [
          h('b', { text: 'Tu cita quedará pendiente de confirmación' }),
          h('span', {
            text: 'Antes de darla por buena te llamamos para verificar el modelo y la avería, ' +
                  'y comprobar que tenemos la pieza y un técnico libre a esa hora. ' +
                  'Así no vienes en balde.'
          })
        ])],
        [nav({ atras: true, siguiente: enviar })]
      ));
    }

    function pasoDatosDomicilio() {
      var alReparar = cobraAlReparar();
      var etiquetaEnviar = alReparar ? 'Solicitar recogida' : 'Pagar y reservar';
      var enviar = boton(etiquetaEnviar, function () {
        if (!validaPersonales(false)) return;
        enviaDomicilio(enviar);
      });

      // El pago de la recogida vacía el carrito para que el importe del checkout
      // cuadre con el resumen de arriba. En la página de reservas eso da igual,
      // pero desde una ficha de producto el cliente puede llevar cosas dentro:
      // hay que avisarle antes de pulsar, no después.
      var avisoCarrito = h('div', {});
      if (esPopup && !alReparar) {
        getJs('/cart.js').then(function (carrito) {
          if (!carrito || !carrito.item_count) return;
          var n = carrito.item_count;
          avisoCarrito.appendChild(h('p', { class: 'fxr-mini', text:
            'Tienes ' + n + (n === 1 ? ' artículo' : ' artículos') + ' en el carrito. ' +
            'Al continuar lo quitamos para que pagues solo esta reparación y su recogida.' }));
        });
      }

      var nota = alReparar
        ? h('div', { class: 'fxr-note' }, [
            h('b', { text: 'No te cobramos nada ahora' }),
            h('span', {
              text: 'La recogida y la entrega son gratis dentro de la M-30. Te llamamos para ' +
                    'acordar el día y confirmarte el presupuesto antes de tocar nada. Se paga ' +
                    'cuando te lo devolvamos reparado, y si decides no repararlo, no hay cargo.'
            })
          ])
        : h('div', { class: 'fxr-note' }, [
            h('b', { text: 'Qué pasa después de pagar' }),
            h('span', {
              text: 'Recibirás un correo con tu referencia y te llamaremos para acordar el día ' +
                    'de la recogida y coordinar al mensajero.'
            })
          ]);

      pintar([].concat(
        alReparar
          ? titulo('Último paso: tus datos',
                   'Con esto ya podemos organizar la recogida. No hay pago ahora.')
          : titulo('Último paso: tus datos y el pago',
                   'El pago se hace en la pasarela segura de la tienda.'),
        [camposPersonales(false)],
        [h('div', { style: 'height:18px' })],
        [resumen(true)],
        [avisoCarrito],
        [nota],
        [nav({ atras: true, siguiente: enviar })]
      ));
    }

    // ------------------------------------------------------------- envío

    function cargando(boton0, texto) {
      boton0.disabled = true;
      boton0.innerHTML = '<span class="fxr-spin"></span>' + texto;
    }

    function restaura(boton0, texto) {
      boton0.disabled = false;
      boton0.textContent = texto;
    }

    function comunes() {
      return {
        nombre: (estado.datos.nombre || '').trim(),
        telefono: (estado.datos.telefono || '').trim(),
        email: (estado.datos.email || '').trim(),
        dispositivo: nombreDispositivo(),
        reparacion: textoReparaciones(),
        precio_reparacion: totalReparaciones(),
        variant_reparacion: (estado.variante || {}).id || '',
        // La lista completa, que es la que manda en el panel: de ella salen el
        // texto corto, el importe y las líneas del ticket. Va como JSON porque
        // el flujo de domicilio se envía como formulario y ahí no hay listas.
        reparaciones: JSON.stringify(estado.seleccion.map(function (x) {
          return { title: x.title, qty: x.qty, price: x.price, variant_id: String(x.id) };
        })),
        // Lo que la ficha ya había descontado (promo de batería y las que
        // vengan). El panel lo resta del presupuesto para que quien llame al
        // cliente le diga el mismo importe que vio en la web.
        descuento: estado.descuento || 0,
        segundos: Math.round((Date.now() - estado.inicio) / 1000),
        trampa: (root.querySelector('[data-fxr-trampa]') || {}).value || ''
      };
    }

    // Con varias reparaciones, el desglose va delante de lo que haya escrito el
    // cliente: es lo primero que necesita ver quien llama para confirmar.
    function comentariosConDetalle() {
      var propio = (estado.datos.comentarios || '').trim();
      var detalle = detalleReparaciones();
      if (!detalle) return propio;
      return propio ? detalle + '\n\n' + propio : detalle;
    }

    function errorEnvio(data) {
      var texto = (data && data.error) || NO_DISPONIBLE;
      var previo = pane.querySelector('.fxr-alert');
      if (previo) previo.remove();
      var caja = aviso(texto);
      pane.querySelector('.fxr-pane').insertBefore(caja, pane.querySelector('.fxr-pane').firstChild);
      if (data && data.campo) marcaError(data.campo, texto);
      else caja.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function enviaTienda(boton0) {
      if (estado.enviando) return;
      estado.enviando = true;
      cargando(boton0, 'Enviando…');

      var cuerpo = Object.assign(comunes(), {
        store_id: estado.tienda,
        starts_at: estado.hueco,
        canal: estado.datos.canal || '',
        comentarios: comentariosConDetalle()
      });

      fetch(api + '/api/reserva/tienda', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cuerpo)
      }).then(leer).then(function (data) {
        estado.enviando = false;
        if (!data.ok) { restaura(boton0, 'Solicitar cita'); return errorEnvio(data); }
        pantallaFinalTienda(data.reserva);
      }).catch(function () {
        estado.enviando = false;
        restaura(boton0, 'Solicitar cita');
        errorEnvio(null);
      });
    }

    function enviaDomicilio(boton0) {
      if (estado.enviando) return;
      var alReparar = cobraAlReparar();
      var etiqueta0 = alReparar ? 'Solicitar recogida' : 'Pagar y reservar';
      // El producto que cobra la recogida solo hace falta si hay que cobrarla.
      if (!servicioId && !alReparar) {
        return errorEnvio({ error: 'La recogida a domicilio no está configurada todavía. ' +
                                   'Escríbenos por WhatsApp y la organizamos contigo.' });
      }
      estado.enviando = true;
      cargando(boton0, 'Guardando tu solicitud…');

      var formulario = new FormData();
      var base = Object.assign(comunes(), {
        direccion: estado.datos.direccion || '',
        cp: estado.datos.cp || '',
        ciudad: estado.datos.ciudad || '',
        franja: estado.datos.franja || '',
        codigo_desbloqueo: estado.datos.codigo_desbloqueo || '',
        consentimiento_codigo: estado.datos.consentimiento_codigo ? 'true' : 'false',
        consentimiento_fotos: estado.datos.consentimiento_fotos ? 'true' : 'false',
        comentarios: comentariosConDetalle(),
        canal: estado.datos.canal || '',
        // Sin cobro por adelantado no se cobra la recogida, así que no se manda
        // importe ni variante del servicio: el panel lo pondría en la ficha como
        // si se hubiera cobrado.
        precio_servicio: alReparar ? 0 : servicioPrecio,
        variant_servicio: alReparar ? '' : servicioId
      });
      Object.keys(base).forEach(function (k) { formulario.append(k, base[k]); });
      formulario.append('foto_frontal', estado.fotos.frontal);
      formulario.append('foto_trasera', estado.fotos.trasera);

      fetch(api + '/api/reserva/domicilio', { method: 'POST', body: formulario })
        .then(leer)
        .then(function (data) {
          if (!data.ok) {
            estado.enviando = false;
            restaura(boton0, etiqueta0);
            return errorEnvio(data);
          }
          // La última palabra sobre el cobro es del panel, no de lo que creyera
          // el navegador al pintar el paso: si dice que no hay pago, no se lleva
          // a nadie a la pasarela.
          if (alReparar || data.reserva.cobro === 'al_reparar') {
            estado.enviando = false;
            pantallaFinalRecogida(data.reserva);
            return null;
          }
          cargando(boton0, 'Llevándote al pago…');
          return alCheckout(data.reserva.ref);
        })
        .catch(function () {
          estado.enviando = false;
          restaura(boton0, etiqueta0);
          errorEnvio(null);
        });
    }

    // El carrito se vacía antes de montar el pedido: si el cliente llevaba algo
    // dentro, el importe del checkout no cuadraría con lo que acaba de ver.
    function alCheckout(ref) {
      var propiedades = {
        'Reserva': ref,
        'Dispositivo': nombreDispositivo(),
        'Recogida en': (estado.datos.direccion || '') + ', ' + (estado.datos.cp || '') +
                       ' ' + (estado.datos.ciudad || ''),
        'Franja preferida': etiquetaFranja(estado.datos.franja)
      };

      // Todas las reparaciones elegidas van al carrito con su cantidad: si no,
      // el importe del checkout no sería el que el cliente acaba de ver.
      var articulos = estado.seleccion.map(function (x) {
        return { id: x.id, quantity: x.qty, properties: propiedades };
      });
      articulos.push({ id: parseInt(servicioId, 10), quantity: 1, properties: { 'Reserva': ref } });

      return fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: articulos })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('carrito');
          // El atributo del carrito es lo que viaja al pedido y lo que lee el
          // webhook para casar el cobro con la reserva.
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Reserva': ref } })
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          estado.enviando = false;
          pantallaPagoManual(ref);
        });
    }

    function etiquetaFranja(id) {
      var lista = (estado.config || {}).franjas || [];
      for (var i = 0; i < lista.length; i++) if (lista[i].id === id) return lista[i].label;
      return id || '';
    }

    // -------------------------------------------------------- pantallas fin

    function pantallaFinalTienda(reserva) {
      estado.enviada = true;
      indice = pasos().length;
      progreso();
      pane.innerHTML = '';
      pane.appendChild(h('div', { class: 'fxr-pane fxr-final' }, [
        h('div', { class: 'fxr-final-ico', html: icono(ICO.check) }),
        h('h2', { text: 'Hemos recibido tu solicitud' }),
        h('p', {
          text: 'Todavía no está confirmada. Te llamamos en breve para verificar los datos y ' +
                'comprobar que tenemos la pieza y el técnico disponibles.'
        }),
        h('div', { class: 'fxr-ref', text: reserva.ref }),
        h('ul', { class: 'fxr-pasos-final' }, [
          h('li', {}, [h('span', { class: 'fxr-n', text: '1' }),
                       h('span', { text: 'Te llamamos para confirmar modelo, avería y hora.' })]),
          h('li', {}, [h('span', { class: 'fxr-n', text: '2' }),
                       h('span', { text: 'Reservamos la pieza y el técnico para ese hueco.' })]),
          h('li', {}, [h('span', { class: 'fxr-n', text: '3' }),
                       h('span', { text: 'Te esperamos en ' + (reserva.tienda || 'la tienda') +
                                          ' el ' + (reserva.cita || 'día acordado') + '.' })])
        ]),
        h('p', { class: 'fxr-mini', style: 'margin-top:22px',
                 text: 'Te hemos enviado un correo con estos datos. ¿Necesitas cambiar algo? ' +
                       'Escríbenos por WhatsApp al 636 981 787.' })
      ]));
    }

    // Recogida sin pago por adelantado: no hay pasarela ni referencia de pedido,
    // así que se cierra aquí, con la misma honestidad que la cita de tienda (no
    // está confirmada hasta que alguien llama).
    function pantallaFinalRecogida(reserva) {
      estado.enviada = true;
      indice = pasos().length;
      progreso();
      pane.innerHTML = '';
      pane.appendChild(h('div', { class: 'fxr-pane fxr-final' }, [
        h('div', { class: 'fxr-final-ico', html: icono(ICO.check) }),
        h('h2', { text: 'Hemos recibido tu solicitud de recogida' }),
        h('p', {
          text: 'No te hemos cobrado nada. Te llamamos para acordar el día, confirmarte el ' +
                'presupuesto y coordinar al mensajero.'
        }),
        h('div', { class: 'fxr-ref', text: reserva.ref }),
        h('ul', { class: 'fxr-pasos-final' }, [
          h('li', {}, [h('span', { class: 'fxr-n', text: '1' }),
                       h('span', { text: 'Te llamamos para confirmar la avería y el presupuesto.' })]),
          h('li', {}, [h('span', { class: 'fxr-n', text: '2' }),
                       h('span', { text: 'Pasa el mensajero a recogerlo el día acordado.' })]),
          h('li', {}, [h('span', { class: 'fxr-n', text: '3' }),
                       h('span', { text: 'Lo reparamos y te lo devolvemos. Se paga entonces, ' +
                                         'y si decides no repararlo, no hay cargo.' })])
        ]),
        h('p', { class: 'fxr-mini', style: 'margin-top:22px',
                 text: 'Te hemos enviado un correo con estos datos. ¿Necesitas cambiar algo? ' +
                       'Escríbenos por WhatsApp al 636 981 787.' })
      ]));
    }

    function pantallaPagoManual(ref) {
      estado.enviada = true;
      pane.innerHTML = '';
      pane.appendChild(h('div', { class: 'fxr-pane fxr-final' }, [
        h('div', { class: 'fxr-final-ico', html: icono(ICO.check) }),
        h('h2', { text: 'Tu solicitud está guardada' }),
        h('p', {
          text: 'No hemos podido abrir la pasarela de pago automáticamente. Guarda esta ' +
                'referencia: te llamamos para cobrarlo y organizar la recogida.'
        }),
        h('div', { class: 'fxr-ref', text: ref }),
        h('p', { class: 'fxr-mini', text: 'También puedes escribirnos por WhatsApp al 636 981 787.' })
      ]));
    }

    // ------------------------------------------------------------- arranque

    function pintaNota(titulo0, texto) {
      pane.innerHTML = '';
      pane.appendChild(h('div', { class: 'fxr-note fxr-note-red' }, [
        h('b', { text: titulo0 }),
        h('span', { text: texto })
      ]));
      bar.style.width = '0';
      etiqueta.textContent = '';
    }

    function notaConContacto(titulo0, texto) {
      var whatsapp = 'https://wa.me/34636981787?text=' + encodeURIComponent('Hola, quiero reservar una reparación en Fixel.');
      return h('div', { class: 'fxr-note fxr-note-red' }, [
        h('b', { text: titulo0 }),
        h('span', { text: texto }),
        h('div', { class: 'fxr-contact-actions', style: 'display:flex;gap:10px;flex-wrap:wrap;margin-top:14px' }, [
          h('a', { class: 'fxr-btn', style: 'display:inline-flex;align-items:center;text-decoration:none', href: whatsapp, target: '_blank', rel: 'noopener noreferrer', text: 'Escribir por WhatsApp' }),
          h('a', { class: 'fxr-btn fxr-btn-ghost', style: 'display:inline-flex;align-items:center;text-decoration:none', href: 'tel:+34636981787', text: 'Llamar al 636 981 787' })
        ])
      ]);
    }

    function pintaNotaContacto(titulo0, texto) {
      pane.innerHTML = '';
      pane.appendChild(notaConContacto(titulo0, texto));
      bar.style.width = '0';
      etiqueta.textContent = '';
    }

    function pintaCargando() {
      pane.innerHTML = '';
      pane.appendChild(h('div', { class: 'fxr-skeleton', style: 'height:190px' }));
    }

    // La configuración (tiendas, franjas, interruptores) se pide una sola vez.
    // En la ficha de producto no se pide al cargar la página: sería una llamada
    // a wa.fixelmovil.com en cada visita a cualquier reparación para algo que
    // casi nadie abre.
    function conConfig(sigue) {
      if (estado.config) { sigue(estado.config); return; }
      pintaCargando();
      get(api + '/api/reserva/config').then(function (cfg) {
        if (!cfg || cfg.ok === false || cfg.abierto === false) {
          pintaNotaContacto('Reservas online no disponibles', NO_DISPONIBLE);
          return;
        }
        estado.config = cfg;
        sigue(cfg);
      });
    }

    // Punto de entrada del popup de la ficha: `handle` es el producto de
    // reparación y `opcion` el nombre de la reparación tal y como aparece en el
    // selector de la ficha (también se acepta `varianteId`). Si algo de eso no
    // cuadra, el asistente no se rompe: cae al flujo completo de siempre y el
    // cliente elige modelo y reparación como en la página de reservas.
    function abrir(opciones) {
      opciones = opciones || {};
      var flujoPrevio = estado.flujo;
      estado.flujo = opciones.flujo === 'domicilio' ? 'domicilio' : 'tienda';

      // Una reserva ya enviada no se retoma: la siguiente vez que se abre la
      // ventana es para hacer otra, y los datos de la anterior estorban.
      if (estado.enviada) {
        estado.enviada = false;
        estado.datos = {};
        estado.fotos = { frontal: null, trasera: null };
        estado.tienda = null;
        estado.dia = null;
        estado.hueco = null;
        estado.prefijado = false;
      }

      conConfig(function (cfg) {
        // Igual que en la portada: el producto del servicio solo se exige si de
        // verdad hay que cobrar la recogida.
        var faltaCobrador = !servicioId && !cobraAlReparar();
        if (estado.flujo === 'domicilio' && (!cfg.domicilio || faltaCobrador)) {
          pintaNotaContacto(
            'La recogida a domicilio no está disponible ahora mismo',
            'Puedes pedir cita en tienda o escribirnos por WhatsApp al 636 981 787 ' +
            'y lo organizamos contigo.'
          );
          return;
        }

        // Si se reabre con exactamente lo mismo, se sigue donde estaba: perder
        // lo ya escrito por cerrar la ventana sin querer sería inaceptable.
        //
        // Pero solo dentro del mismo flujo y sin haber llegado al final: si se
        // sale de una cita a medias y se pulsa "Recogida y entrega", el paso en
        // el que estaba no significa nada en el otro flujo y aparecía una
        // pantalla del medio en vez del primer paso.
        var mismoProducto = estado.producto && estado.producto.handle === opciones.handle;
        var reanudable = flujoPrevio === estado.flujo && indice >= 0 && indice < pasos().length;
        if (estado.prefijado && mismoProducto && reanudable && mismaSeleccion(opciones)) {
          fijaDescuento(opciones);
          ir(indice);
          return;
        }

        if (!opciones.handle) { estado.prefijado = false; ir(-1); return; }

        pintaCargando();
        getJs('/products/' + opciones.handle + '.js').then(function (p) {
          if (!p || !p.variants) return sinPrefijar();
          return conMetadatos(p, opciones.handle).then(function (completo) {
            var pedidas = listaPedida(opciones);
            var elegidas = [];
            pedidas.forEach(function (pide) {
              var v = buscaVariante(completo, pide);
              if (v) elegidas.push({ id: v.id, title: v.title, price: v.price / 100, qty: pide.qty || 1 });
            });

            estado.producto = completo;
            // Se exige encontrarlas todas. Si falta una, arrancar la reserva
            // dejándola fuera sería cobrar de menos y reparar de menos: mejor
            // preguntar en el paso de siempre, con el modelo ya resuelto.
            if (!elegidas.length || elegidas.length !== pedidas.length) {
              estado.prefijado = false;
              fijaSeleccion([]);
              ir(1);
              return;
            }
            estado.prefijado = true;
            fijaSeleccion(elegidas);
            fijaDescuento(opciones);
            ir(0);
          });
        }).catch(sinPrefijar);
      });
    }

    // La ficha puede mandar una sola reparación (`opcion`/`varianteId`) o la
    // lista con cantidades (`seleccion`). Se normalizan a lo mismo.
    function listaPedida(opciones) {
      if (opciones.seleccion && opciones.seleccion.length) {
        return opciones.seleccion.map(function (x) {
          return { varianteId: x.varianteId || x.id, opcion: x.opcion || x.title, qty: x.qty || 1 };
        });
      }
      if (opciones.varianteId || opciones.opcion) {
        return [{ varianteId: opciones.varianteId, opcion: opciones.opcion, qty: opciones.qty || 1 }];
      }
      return [];
    }

    function buscaVariante(producto, pide) {
      var elegida = null;
      producto.variants.forEach(function (v) {
        if (elegida) return;
        if (pide.varianteId && String(v.id) === String(pide.varianteId)) elegida = v;
        else if (pide.opcion && v.title === pide.opcion) elegida = v;
      });

      // Si el producto tiene más de una opción (reparación + calidad, por
      // ejemplo), el título de la variante no es solo el nombre de la
      // reparación. Se busca entre las que contengan esa opción y solo se acepta
      // si no hay ambigüedad: equivocar la variante es equivocar el precio, y
      // eso no se adivina.
      if (!elegida && pide.opcion) {
        var candidatas = producto.variants.filter(function (v) {
          return (v.options || []).indexOf(pide.opcion) !== -1 && v.available !== false;
        });
        if (candidatas.length === 1) elegida = candidatas[0];
      }
      return elegida && elegida.available !== false ? elegida : null;
    }

    // El descuento no se calcula: se deduce de lo que la ficha ya estaba
    // enseñando. Si su total es menor que la suma de las reparaciones, esa
    // diferencia es la promoción, y se respeta tal cual. Así valen las de hoy y
    // las que añadan mañana sin tener que repetir aquí ninguna regla.
    function fijaDescuento(opciones) {
      estado.descuento = 0;
      if (!estado.prefijado || opciones.totalFicha === null || opciones.totalFicha === undefined) return;
      var suma = sumaReparaciones();
      var diferencia = redondea(suma - opciones.totalFicha);
      // Solo descuentos creíbles: ni negativos (la ficha nunca cobra más) ni
      // mayores que el propio importe.
      if (diferencia > 0.004 && diferencia <= suma) estado.descuento = diferencia;
    }

    function mismaSeleccion(opciones) {
      var pedidas = listaPedida(opciones);
      if (pedidas.length !== estado.seleccion.length) return false;
      return pedidas.every(function (pide, i) {
        var actual = estado.seleccion[i];
        var mismoId = pide.varianteId && String(actual.id) === String(pide.varianteId);
        return (mismoId || actual.title === pide.opcion) && actual.qty === (pide.qty || 1);
      });
    }

    function sinPrefijar() {
      estado.prefijado = false;
      estado.producto = null;
      fijaSeleccion([]);
      ir(0);
    }

    if (esPopup) {
      // El popup no pinta nada hasta que alguien pulsa el botón de la ficha.
      root.fxrAbrir = abrir;
      return;
    }

    conConfig(function () { ir(-1); });
  }

  function arranca() {
    document.querySelectorAll('[data-fxr-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
  // El editor de temas recarga secciones sueltas sin recargar la página.
  document.addEventListener('shopify:section:load', arranca);
})();
